module.exports = __webpack_public_path__ + "static/img/8.22ce401.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/在线教育/8.png
// module id = CzJA
// module chunks = 1